import { dataShared } from '.'
import AssessmentService from '../services/assessment'
import { createStore } from 'vuex'
import { showToast as toast } from "@/helpers/UseToasts";
import router from '@/router';

export const dataAssessment = createStore({
    state: () => {
        return {
            overview: null,         // payload do GET overview
            attempt: null,          // { id, status, max_score, started_at }
            questions: [],
            last_attempt: null,
        }
    },
    getters: {
        canStart: (st) => !!st.overview?.can_start,
        attemptsRemaining: (st) => st.overview?.attempts?.remaining ?? 0,
        attemptId: (st) => st.attempt?.id ?? null,
        questions: (st) => st.questions,
        overview: (st) => st.overview,
        lastAttemptId: (st) => st.last_attempt?.attempt?.id ?? null,
    },
    mutations: { 
        SET_OVERVIEW(st, payload) { st.overview = payload },
        SET_ATTEMPT(st, payload)  { st.attempt = payload },
        SET_LAST_ATTEMPT(st, payload)  { st.last_attempt = payload },
        SET_QUESTIONS(st, list)   { st.questions = Array.isArray(list) ? list : [] },
        RESET_ATTEMPT(st) { 
            st.attempt = null; 
            st.questions = [] 
        },
    },
    actions: {
        async loadOverview({ commit }, trainingId) {
            dataShared.dispatch('activeLoading')
            const { data } = await AssessmentService.getOverview(trainingId)
            commit('SET_OVERVIEW', data)

            dataShared.dispatch('desactiveLoading')
            return data
        },

        async startAttempt({ commit }, trainingId) {
            const { data } = await AssessmentService.startAttempt(trainingId)
            commit('SET_ATTEMPT', data.attempt)
            commit('SET_QUESTIONS', data.questions)
            return data
        },

        async submitAllAnswers({ getters }, answersObj) {
            const attemptId = getters.attemptId
            if (!attemptId) throw new Error('Attempt não iniciado')

            // normaliza { [qid]: optionId } -> [{question_id, option_id}]
            const arr = Object.entries(answersObj).map(([qid, oid]) => ({
                question_id: Number(qid),
                option_id: Number(oid),
            }))
            await AssessmentService.submitAnswers(attemptId, arr)
            .catch((err) => {
                if (err?.response?.data?.errors && err.response.data?.message) {
                  router.push({ name: "home" });
                  return toast("Aviso", err.response.data?.message, "error");
                }
            
                if (err?.response?.data?.errors && response.data?.message) {
                  router.push({ name: "home" });
                  return toast("Aviso", err.response.data?.message, "error");
                }
            
                if (err?.response?.data?.errors && response.data?.message) {
                  router.push({ name: "auth" });
                  return toast("Aviso", err.response.data?.message, "error");
                }
              });

        },

        async finalizeAttempt({ commit, getters }, payload) {
            const attemptId = getters.attemptId
            if (!attemptId) throw new Error('Attempt não iniciado')
            const { data } = await AssessmentService.finalizeAttempt(attemptId, payload)
            commit('SET_LAST_ATTEMPT', data)
            return data // snapshot final (score/status)
        },

        resetAttempt({ commit }) { commit('RESET_ATTEMPT') },
    }
})